import { useEffect, useState } from "react";
import {
  Container,
  ContainerRow,
  ContainerView,
} from "../../components/Container";
import { Form } from "antd";
import { useApp } from "../../contexts";
import { FormButton, FormItemRow, FormSelect } from "../../components/Form";
import {
  errorView,
  formatCurrency,
  postMintNft,
  getWithdrawFee,
  itemsSearch,
  postWithdraw,
  getDexWallet,
  itemDetail,
} from "../../services/app";
import { ModalMintNotify } from "../../components/ModalMintNotify";
import { ModalMintPreview } from "../../components/ModalMintPreview";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TitleWithBack } from "../../components/Layout";
import FormInput from "../../components/FormCustom2/Input";
import { error, success } from "../../Notification";
import IconPicture from "../../components/Icons/IconPicture";
import IconMotion from "../../components/Icons/IconMotion";
import { useMemo } from "react";
import CustomVideo from "../../components/video/CustomVideo";
import VideoPlayer from "../../components/video/MobileVideo";
import { useWindowSize } from "../../hook/useWindowSize";
import { AIAIcon } from "../../components/Icons/AIAIcon";
let timeout;
let currentValue;

export default function MintNFT(props) {
  const {
    T,
    loading,
    language,
    setLoading,
  } = useApp();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState(searchParams.get("item_code") || null);
  const [fee, setFee] = useState(0);
  const [form] = Form.useForm();
  const [available, setAvailable] = useState(false);
  const [web3Wallet, setWeb3Wallet] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);
  const [isShowSuccess, setIsShowSuccess] = useState(false);
  const [desLenght, setDesLenght] = useState(0);
  const [nftType, setNftType] = useState("");
  const [isShowDetail, setIsShowDetail] = useState(false);
  const [items, setItems] = useState([]);
  const [nftOptions, setNFTOptions] = useState([]);
  const [errors, setErrors] = useState([]);
  const [randomClass, setRandomClass] = useState("");
  const [isAutoPlay, setIsAutoPlay] = useState(false)
  const size = useWindowSize();

  const artTypeOptions = useMemo(() => {
    return [
      { value: "", label: T("All") },
      { value: "photo", label: T("Photo Art") },
      { value: "motion", label: T("Motion Art") },
    ]
  }, [language])
  useEffect(() => {
    loadData();
    loadDexData();
  }, []);
  
  useEffect(() => {
    if (code) {
      form.setFieldsValue({"internalTokenId": code})
      form.setFieldsValue({"nftType": searchParams.get("nft_type") || null})
      setTimeout(() => {
        loadData(code)
        onUpdateData();
      }, [1000])
    }
  }, [code]);


  const onBack = () => {
    navigate(-1);
  };

  const loadData = async (token) => {
    setLoading(true);
    itemsSearch({token: token, page: 0, size: 20, itemTypes: [9], isNotNFT: true }).then((res) => {
      const options = (res?.data?.data?.items?.rows || []).map((item) => ({
        value: item.token,
        label: item.name,
      }));
      setNFTOptions(options);
      setItems(res?.data?.data?.items?.rows || []);
      if (token) {
        if ((res?.data?.data?.items?.rows || []).filter((i) => i.token === token)?.length > 0) {
          handleChange(token, res?.data?.data?.items?.rows)
        }else{
          navigate(-1)
        }
      }
    });
    setLoading(false);
  };
  const loadDexData = async () => {
    setLoading(true);
    let result = await getDexWallet();
    if (result.status === 200) {
      const address = result?.data?.data?.public_address;
      setWeb3Wallet(address);
      form.setFieldsValue({
        wallet: address
      })
    }
    setLoading(false);
  };
  useEffect(() => {
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemSelected?.item?.id % 7;
    setRandomClass(`suzu-card-image-${arr[random]}`);
  }, [itemSelected]);
  
  const loadFee = async (amount, currencyCode) => {
    let result = await getWithdrawFee(amount, currencyCode);
    if (result?.status === 200) {
      setFee(result?.data?.data || 0);
    }
  };
  
  const handleChange = async (token, listItems) => {
    let itemSelect = items.find((item) => item.token === token);
    if (listItems?.length > 0) {
      itemSelect = listItems.find((item) => item.token === token);
    }
    let result = await itemDetail(itemSelect.id);
    if (result?.status === 200) {
      setItemSelected(result?.data?.data)
      const options = [{
        value: result?.data?.data?.item?.token || '',
        label: result?.data?.data?.item?.name || '',
      }]
      setNFTOptions(options);
    }
  };

  const onMint = async (values) => {
    setLoading(true);
    const result = await postMintNft({
      internalTokenId: values.internalTokenId,
      description: values.description || "",
    });
    setLoading(false);
    if (result?.data?.error?.status) {
      success(
        T(
          "Your mint NFT has been created and under processing. Please check your transaction history on AI Avatar app."
        )
      );
      handleRedirect()
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        error(T("NFT mint unsuccessfully. Please check information and try again."));
      }
    }
  };

  const onUpdateData = () => {
    const values = form.getFieldsValue();
    setDesLenght(values?.description?.trim()?.length || 0)
    if (values.internalTokenId) {
      
    }
    setAvailable(values.internalTokenId && values.wallet);
  };
  const handleChangeNftType = (val) => {
    setNftType(val)
    form.setFieldsValue({internalTokenId: ''})
    setItemSelected(null)
    itemsSearch({ itemTypes: [9], isNotNFT: true, tagNFT: val ? [val] : undefined }).then((res) => {
      const options = (res?.data?.data?.items?.rows || []).map((item) => ({
        value: item.token,
        label: item.name,
      }));
      setNFTOptions(options);
      setItems(res?.data?.data?.items?.rows || []);
    });
  };

  const fecthNftItems = async (keyword) => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    currentValue = keyword;
    const searchItems = () => {
      itemsSearch({ name: keyword, itemTypes: [9], isNotNFT: true, tagNFT: nftType ? [nftType] : undefined }).then((res) => {
        if (currentValue === keyword) {
          const options = (res?.data?.data?.items?.rows || []).map((item) => ({
            value: item.token,
            label: item.name,
          }));
          setNFTOptions(options);
          setItems(res?.data?.data?.items?.rows || []);
        }
      });
    };
    if (keyword) {
      timeout = setTimeout(searchItems, 300);
    } else {
      setNFTOptions([]);
    }
  };
  const handleRedirect = () => {
    navigate(`/asset`);
  }
  const handleMouseEnter = () => {
    if (!isAutoPlay) setIsAutoPlay(true) 
  }
  const handleMouseLeave = () => {
    if (isAutoPlay) setIsAutoPlay(false)
  }
  return (
    <Container>
      <ContainerView>
        <TitleWithBack
          className="mint"
          title={T("Mint NFT")}
          onClick={onBack}
        />
        <div className="mint-container">
          <div className="mint-row">
            <Form
              form={form}
              className="mint-form"
              onFinish={(values) => {
                onMint(form.getFieldsValue());
              }}
              onValuesChange={() => {
                onUpdateData();
              }}
            >
              <FormItemRow
                {...errorView(errors, "nftType")}
                name={"nftType"}
                label={T("Art Type")}
                className={"input-row-mint"}
              >
                <FormSelect
                  placeholder={T("Art Type")}
                  className="input-mint"
                  suffixIcon={null}
                  filterOption={false}
                  onChange={(e) => handleChangeNftType(e)}
                  notFoundContent={null}
                  options={artTypeOptions || []}
                />
              </FormItemRow>
              <FormItemRow
                {...errorView(errors, "internalTokenId")}
                name={"internalTokenId"}
                label={T("Avatar name")}
                rules={[{ required: true, message: T("Avatar is required!") }]}
                className={"input-row-mint"}
              >
                <FormSelect
                  showSearch
                  placeholder={T("Type avatar name")}
                  className="input-mint"
                  defaultActiveFirstOption={false}
                  suffixIcon={null}
                  filterOption={false}
                  onSearch={fecthNftItems}
                  onChange={(e) => handleChange(e)}
                  notFoundContent={null}
                  options={nftOptions || []}
                />
              </FormItemRow>
              <div className="relative">
                <FormItemRow
                  name={"description"}
                  label={
                    <>
                      <div className="flex justify-between items-center w-full">
                        <span>{T("Description")}</span>
                        <span>{T("Optional")}</span>
                      </div>
                    </>
                  }
                  className={"input-row-mint no-after"}
                >
                  <FormInput
                    type="textarea"
                    placeholder={T("Enter a description here ...")}
                    className="input-mint px-[15px] py-[5px]"
                    maxLength={5000}
                    autoSize={{ minRows: 3 }}
                  />
                </FormItemRow>
                <div className=" absolute bottom-[5px] right-[10px] flex space-x-2 items-center">
                  <div className="mt-[10px] text-[#818181] text-xs">
                    {desLenght}/5000
                  </div>
                </div>
              </div>
              
              <FormItemRow
                name={"wallet"}
                label={T("Recipient’s address")}
                className={"input-row-mint"}
                rules={[
                  {
                    required: true,
                    message: T("Recipient’s address is required!"),
                  },
                ]}
              >
                <FormSelect className="input-mint no-arrow">
                  <FormSelect.Option
                    value={web3Wallet}
                    className={"min-h-[45px] items-center"}
                  >
                    <div className="flex justify-start space-x-[6px] items-center">
                      <span className="w-[24px] h-[24px]">
                        <AIAIcon />
                      </span>
                      <span className="truncate">
                        {T("AI Avatar Web3 Wallet Address")}
                      </span>
                    </div>
                  </FormSelect.Option>
                </FormSelect>
              </FormItemRow>
              <div className="w-full lg:w-[300px] flex justify-between items-center mt-[25px] lg:mt-[48px] mb-[48px]">
                <div className="text-base font-semibold text-black">
                  {T("Minting Fee:")}
                </div>
                <div className="text-base font-semibold text-black">
                  {T("Free")}
                </div>
              </div>
              <div className="hidden lg:block w-full h-[1px] bg-[#0000001A] mb-[48px]"></div>
              <div>
                <FormButton
                  disabled={!available || loading}
                  htmlType={"button"}
                  onClick={() => {
                    form.submit();
                  }}
                >
                  {T("Mint")}
                </FormButton>
              </div>
            </Form>
            <div className="mint-right">
              <div className={`${itemSelected?.item?.tag_nft_type !== 'motion' ? "mint-image": "mint-video"}`}>
                {itemSelected ? (
                  <div className={`${itemSelected?.item?.tag_nft_type == 'photo' ? randomClass : 'bg-slate-50'} h-full relative`} >
                    {
                      itemSelected?.item?.tag_nft_type == 'motion'? <>
                        {
                          size.width < 768 ? <div>
                            <VideoPlayer source={itemSelected?.item?.long_video_url} isAutoPlay={isAutoPlay} className={'flex justify-center'} isShowControls={true}/>
                          </div>: <div 
                            onMouseEnter={() => handleMouseEnter()}
                            onMouseLeave={handleMouseLeave}
                            >
                              <CustomVideo source={itemSelected?.item?.long_video_url} isAutoPlay={isAutoPlay} className={'flex justify-center'} isShowControls={true}/>
                            </div>
                        }

                      </>: <img
                      className={`w-full h-full object-cover`}
                      src={itemSelected?.item?.img}
                      onContextMenu={(e) => e.preventDefault()}
                      alt=""
                    />
                    }
                    {itemSelected?.item?.tag_nft_type == 'photo' ? <div className="item-tag item-picture">
                        <IconPicture /><span>{T('Photo')}</span>
                    </div>: <></>}
                    {itemSelected?.item?.tag_nft_type == 'motion' ? <div className="item-tag item-motion">
                        <IconMotion /> <span>{T('Motion')}</span>
                    </div>: <></>}
                  </div>
                ) : (
                  <div className="bg-[#F5F5F5] flex justify-center items-center mint-no-image">
                    {T("Your NFT show here")}
                  </div>
                )}
              </div>
              {itemSelected ? (
                <>
                  <div className="text-base text-black font-semibold text-center mint-item-title">
                    {itemSelected?.item?.name}
                  </div>
                  <div className="flex justify-center  mint-item-action">
                    <button
                      type="button"
                      className="bg-white leading-[40px] text-black border border-solid border-black  rounded-[10px] min-w-[175px] px-[20px] h-[40px] font-medium"
                      onClick={() => setIsShowDetail(true)}
                    >
                      {T("View detail")}
                    </button>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </ContainerView>
      {isShowDetail && (
        <ModalMintPreview
          onClose={() => setIsShowDetail(false)}
          onSubmit={() => setIsShowDetail(false)}
          itemData={itemSelected}
          isMobile={size.width < 768}
        />
      )}
    </Container>
  );
}
